import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend"
import LanguageDetector from "i18next-browser-languagedetector"
import Dari from "../translate/dr/translation.json"
import English from "../translate/en/translation.json"
const resources = {
  en: {
    translation: English,
  },
  fa: {
    translation: Dari,
  },
};
i18n
  .use(LanguageDetector)
  .use(Backend)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: "en",
    supportedLngs: ["en", "fa"],
    fallbackLng: "en",
    debug: false,
    keySeparator: false,
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n;
